const cartCouponForm = {
  cartCouponFormNode: null,

  init() {
    this.cartCouponFormNode = document.querySelector('.coupon-form-heading');

    if(this.cartCouponFormNode) {
      this.cartCouponFormNode.addEventListener('click', (e) => e.target.nextElementSibling.classList.toggle('is-hidden'), false);
    }
  },
};

export default cartCouponForm;



// WEBPACK FOOTER //
// ./scripts/modules/cart-show-coupon-field.js